import { render, staticRenderFns } from "./ResearchBiosamplePlot.vue?vue&type=template&id=c1cccec0"
import script from "./ResearchBiosamplePlot.vue?vue&type=script&lang=js"
export * from "./ResearchBiosamplePlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchBiosamplePlot.vue?vue&type=style&index=0&id=c1cccec0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1cccec0')) {
      api.createRecord('c1cccec0', component.options)
    } else {
      api.reload('c1cccec0', component.options)
    }
    module.hot.accept("./ResearchBiosamplePlot.vue?vue&type=template&id=c1cccec0", function () {
      api.rerender('c1cccec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchBiosamplePlot.vue"
export default component.exports